import { Tag as TagAnt } from 'antd';
import { forwardRef } from 'react';

export const Tag = forwardRef<HTMLSpanElement, React.ComponentProps<typeof TagAnt>>((props, ref) => {
  return <TagAnt ref={ref} variant="outlined" {...props} />;
});
